import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Tooltip } from 'ui/tooltip';
import { useDrawerContext } from 'ui/fullScreen';
import { useGetCanManageBaseTemplates, useGetMessagingPermission } from '..';

import { MessagingPermissionOptions } from '../types';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { displayContent } from '../content';

export const DetailsButton = () => {
  const { toggleDrawer } = useDrawerContext();
  const { campaignId: isCampaignFlow, experimentFlow: isExperimentFlow } = useQueryParamContext();
  const messagingPermission = useGetMessagingPermission();
  const canManageBaseTemplates = useGetCanManageBaseTemplates();
  const isButtonDisabled =
    isCampaignFlow || isExperimentFlow
      ? messagingPermission === MessagingPermissionOptions.VIEW_ONLY
      : !canManageBaseTemplates;
  const tooltipContent =
    isCampaignFlow || isExperimentFlow
      ? displayContent.tooltipViewOnlyPermission
      : displayContent.tooltipManageBaseTemplatesPermission;

  return (
    <Tooltip isEnabled={isButtonDisabled} tooltipContent={tooltipContent}>
      <Button
        data-test={'template-editor-details-button'}
        isDisabled={isButtonDisabled}
        onClick={() => toggleDrawer()}
        size={BUTTON_SIZES.MEDIUM}
        variant={BUTTON_VARIANTS.SECONDARY}
      >
        <span>{displayContent.btnDetails}</span>
      </Button>
    </Tooltip>
  );
};

export default DetailsButton;
